<template>
  <div></div>
</template>
<script>
export default {
  name: "Login1",
  created() {
    // 已取消短信登录，统一走账号密码登录
    this.$router.replace({ path: "/login" });
  }
};
</script>
